import { render, staticRenderFns } from "./ProductActionsBar.vue?vue&type=template&id=b9fe5a44&"
import script from "./ProductActionsBar.vue?vue&type=script&lang=ts&"
export * from "./ProductActionsBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports